module.exports = __webpack_public_path__ + "static/media/8.Drip Pipes.d013e138.jpeg";